import { getStatuses } from '../utils/tableHelper'

export default () => ({
  loadingItems: false,
  dashboardData: {
    TOTAL: 0,
    EMERGENCY: 0,
    VERY_URGENT: 0,
    URGENT: 0,
    NOT_VERY_URGENT: 0,
    NOT_URGENT: 0
  },
  query: '',
  status: getStatuses()[1],
  items: [],
  total: 0,
  page: 1,
  firstItem: null
})
